export const isNotUndefinedNorNull = (value?: string | null): boolean =>
	value !== undefined && value !== 'null' && value !== null && value !== '';
